/* Source: /app/components/ChatInput.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useRef, useEffect } from "react";
import { IconSend, IconPlayerStop } from "@tabler/icons-react";
import { useState } from "@jac/runtime";
function ChatInput(props) {
  const {onSendMessage, disabled: disabled = false, placeholder: placeholder = "Ask about Jac syntax, functions, loops, classes, or request code examples...", isLoading: isLoading = false, onStop: onStop = null, mode: mode = "rag", onModeChange: onModeChange = null} = props;
  const [inputValue, setInputValue] = useState("");
  let textareaRef = useRef(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      let scrollHeight = textareaRef.current.scrollHeight;
      let newHeight = Math.max(52, Math.min(scrollHeight, 200));
      textareaRef.current.style.height = (String(newHeight) + "px");
    }
  }, [inputValue]);
  function handleSubmit(e) {
    e.preventDefault();
    if (((inputValue.trim() && !disabled) && !isLoading)) {
      onSendMessage(inputValue.trim());
      setInputValue("");
      if (textareaRef.current) {
        textareaRef.current.style.height = "52px";
      }
    }
  }
  function handleKeyDown(e) {
    if (((e.key === "Enter") && !e.shiftKey)) {
      e.preventDefault();
      handleSubmit(e);
    }
  }
  function handleInputChange(e) {
    setInputValue(e.target.value);
  }
  let canSend = ((inputValue.trim() && !disabled) && !isLoading);
  let sendClass = "jc-send-btn";
  if (canSend) {
    sendClass = "jc-send-btn ready";
  }
  let buttonBg = "linear-gradient(135deg, #f97316 0%, #ea580c 100%)";
  let buttonOpacity = "1";
  let buttonIcon = __jacJsx(IconSend, {"size": 16}, []);
  if (isLoading) {
    buttonBg = "#374151";
    buttonIcon = __jacJsx(IconPlayerStop, {"size": 16}, []);
  } else if (!canSend) {
    buttonOpacity = "0.5";
  }
  return __jacJsx("div", {"style": {"paddingTop": "8px", "paddingLeft": "12px", "paddingRight": "12px", "paddingBottom": "16px"}}, [__jacJsx("form", {"onSubmit": handleSubmit, "style": {"maxWidth": "768px", "margin": "0 auto"}}, [__jacJsx("div", {"className": "jc-composer"}, [__jacJsx("textarea", {"ref": textareaRef, "value": inputValue, "onChange": handleInputChange, "onKeyDown": handleKeyDown, "placeholder": placeholder, "disabled": (disabled && !isLoading), "style": {"flex": "1", "minHeight": "52px", "maxHeight": "200px", "padding": "14px 10px", "fontSize": "16px", "lineHeight": "1.55", "background": "transparent", "border": "none", "color": "var(--text-primary)", "resize": "none", "outline": "none", "fontFamily": "system-ui, -apple-system, sans-serif", "overflow": "auto"}}, []), __jacJsx("button", {"type": (isLoading ? "button" : "submit"), "onClick": (isLoading ? onStop : null), "disabled": (!canSend && !isLoading), "className": sendClass, "style": {"background": buttonBg, "opacity": buttonOpacity, "cursor": ((canSend || isLoading) ? "pointer" : "not-allowed"), "marginBottom": "2px"}}, [buttonIcon])])]), (onModeChange ? __jacJsx("div", {"style": {"maxWidth": "768px", "margin": "12px auto 0 auto", "display": "flex", "justifyContent": "center"}}, [__jacJsx("div", {"className": "jc-mode-toggle"}, [[{"value": "rag", "label": "RAG"}, {"value": "mcp", "label": "MCP"}, {"value": "both", "label": "Both"}].map(opt => {
    let isActive = (mode === opt.value);
    let btnClass = "jc-mode-btn";
    if (isActive) {
      btnClass = "jc-mode-btn active";
    }
    return __jacJsx("button", {"key": opt.value, "type": "button", "disabled": isLoading, "className": btnClass, "onClick": () => onModeChange(opt.value)}, [opt.label]);
  })])]) : null)]);
}
/*jac:refresh-boundary*/;
export {ChatInput};
//# sourceMappingURL=ChatInput.js.map
